import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AuthorizeIntegrationParams, CompanyDetails } from './auth-models';

export const ConsentActions = createActionGroup({
  source: 'Consent',
  events: {
    'Get Company Details': props<{ clientId: string }>(),
    'Get Company Details Success': props<{ details: CompanyDetails }>(),
    'Get Company Details Failure': props<{ error: string }>(),

    'Authorize Integration': props<{ authorizeIntegrationParams: AuthorizeIntegrationParams }>(),
    'Authorize Integration Success': props<{ redirect_uri: string }>(),
    'Authorize Integration Failure': props<{ error: string }>(),

    'Deny Integration': emptyProps(),
  },
});
